import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CHUNK_SIZE = 5 * 1024 * 1024;

// Uploads a file in 5MB chunks; returns the stored file URL.
export const uploadInChunks = async (file, folder, onProgress) => {
  const uploadId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const total = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
  let url = null;
  for (let index = 0; index < total; index++) {
    const form = new FormData();
    form.append('upload_id', uploadId);
    form.append('index', index);
    form.append('total', total);
    form.append('filename', file.name);
    form.append('content_type', file.type || 'application/octet-stream');
    form.append('folder', folder);
    form.append('chunk', file.slice(index * CHUNK_SIZE, (index + 1) * CHUNK_SIZE));
    const { data } = await axios.post(`${API}/admin/uploads/chunk`, form, { withCredentials: true });
    onProgress?.(Math.round(((index + 1) / total) * 100));
    if (data.status === 'complete') url = data.url;
  }
  return url;
};
